
/// <reference types="vite/client" />

import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error("Could not find root element to mount to");
}

const root = createRoot(rootElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Unregister service worker in development mode to prevent stale chunk / React version caching issues
if (import.meta.env.DEV && 'serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then(registrations => {
    let unregisteredAny = false;
    const promises = registrations.map(registration => {
      return registration.unregister().then(success => {
        if (success) {
          unregisteredAny = true;
          console.log('Unregistered active service worker in development mode');
        }
      });
    });

    Promise.all(promises).then(() => {
      if (unregisteredAny) {
        if (typeof caches !== 'undefined') {
          caches.keys().then(names => {
            Promise.all(names.map(name => caches.delete(name))).then(() => {
              console.log('Cleared all service worker caches');
              window.location.reload();
            });
          });
        } else {
          window.location.reload();
        }
      }
    });
  });
}

// Register Service Worker in Production ONLY on supported, non-sandboxed environments
if ('serviceWorker' in navigator && import.meta.env.PROD) {
  const isSandboxedAudit = typeof window !== 'undefined' && (
    Boolean((window as any).wrsParams) ||
    Boolean((window as any).__LHR__) ||
    navigator.userAgent.includes('HeadlessChrome') ||
    navigator.userAgent.includes('Lighthouse')
  );

  if (!isSandboxedAudit) {
    window.addEventListener('load', () => {
      try {
        navigator.serviceWorker.register('/sw.js')
          .then(registration => {
            console.log('[PWA] Service Worker registered with scope:', registration.scope);
          })
          .catch(err => {
            console.debug('[PWA] Service Worker registration skipped:', err?.message || err);
          });
      } catch (err) {
        console.debug('[PWA] Service Worker registration not supported:', err);
      }
    });
  }
}
